/** When your routing table is too long, you can split it into small modules **/

// import Layout from '@/layout'

const billsRouter = {
    path: '/',
    component: () => import('@/views/base/Index'),
    children: [
      {
        name: '结算管理',
        path: 'bills/:id',
        component: () => import('@/views/bills/List'),
      },
      {
        name: '文件管理',
        path: 'bills/file/:id',
        component: () => import('@/views/bills/File'),
      },
      {
        name: '打印结算单',
        path: 'bills/:id/:seq',
        component: () => import('@/views/bills/PrintBill'),
      },
      {
        name: '打印合同',
        path: 'bills/contract/:id/:seq',
        component: () => import('@/views/bills/PrintContract'),
      },
      {
        name: '打印买卖合同',
        path: 'bills/contractsj/:id/:seq',
        component: () => import('@/views/bills/PrintContractForSJ'),
      },
      {
        name: '打印善新苑买卖合同',
        path: 'bills/contractsx/:id/:seq',
        component: () => import('@/views/bills/PrintContractForSX'),
      },
      {
        name: '打印和善家园买卖合同',
        path: 'bills/contractshs/:id/:seq',
        component: () => import('@/views/bills/PrintContractForHS'),
      },
      {
        name: '打印同意书',
        path: 'bills/settle/:id/:surplus/:seq',
        component: () => import('@/views/bills/PrintSettle'),
      },
    ],
  }
  
  export default billsRouter